import {
  Component,
  HostBinding,
  Input,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  encapsulation: ViewEncapsulation.ShadowDom,
})
export class CardComponent {
  displaySlotBody: boolean = false;
  @Input() customStyles: any = {};

  @Input() boxShadow: string = '0px -16px 24px rgba(0, 51, 161, 0.05)';
 
  @Input() boxShadowExt: string =
    '0px 6px 8px -6px rgba(0, 51, 161, 0.06), 0px 8px 16px -6px rgba(0, 51, 161, 0.06)';
  @Input() borderRadius: string = '24px';

  @Input() isLoading: boolean = false;
  @Input() skeletonStyles: any = {};

  @HostBinding('style.borderRadius') borderRadiusHost = this.borderRadius;
  @HostBinding('style.boxShadow') boxShadowHost = this.boxShadowExt;
  @HostBinding('style.-webkit-box-shadow') boxShadowHostWebkit =
    this.boxShadowExt;

  slotChangeBody($event) {
    const assigned = $event.target.assignedNodes();
    if (assigned.length > 0) {
      this.displaySlotBody = true;
    }
  }
}
